<svg width="25" height="24" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.25 20h-3V5h3v6h6V5h3v15h-3v-6h-6v6z" fill-rule="evenodd" />
</svg>
